import axios from "@/libs/api.request.js";

// 埋点上报接口
export function actionTrackApi (data) {
  return axios.request({
    url: `/platform-box-user/user/event-track`,
    data,
    method: "post",
  })
}

// 获取绑定用户id
export function getBindingUserIdApi (data) {
  return axios.request({
    url: `/platform-box-game/wechat/getBindUserId`,
    data,
    method: "post",
  })
}

// 根据 gameid 获取游戏承接信息
export function getGameInfoById (data) {
  return axios.request({
    url: `/platform-box-game/wechat/getWechatGameInfo`,
    data,
    method: "post",
  })
}

// 获取 ip
export function getIPAddr () {
  return fetch('https://api.ipify.org', { method: 'get', headers: { 'Content-Type': 'text/plain' } })
}

// 获取角色绑定信息
export function getRoleBindInfo (data) {
  return axios.request({
    url: `/platform-box-game/wechat/roleBindInfo`,
    data,
    method: "post",
  })
}

// 角色信息查询
export function getRoleInfoByRoleId (data) {
  return axios.request({
    url: `/platform-box-game/wechat/roleInfo`,
    data,
    method: "post",
  })
}

// 绑定角色
export function bindAccountApi (data) {
  return axios.request({
    url: `/platform-box-game/wechat/bindAccount`,
    data,
    method: "post",
  })
}
